import { render, staticRenderFns } from "./ProofreadProblems.vue?vue&type=template&id=32aae3b4&scoped=true&lang=pug&"
import script from "./ProofreadProblems.vue?vue&type=script&lang=ts&"
export * from "./ProofreadProblems.vue?vue&type=script&lang=ts&"
import style0 from "./ProofreadProblems.vue?vue&type=style&index=0&id=32aae3b4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aae3b4",
  null
  
)

export default component.exports